// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const BuildingAreaPure = createIcon(`
<svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="120" height="120"
	 viewBox="0 0 120 120" style="enable-background:new 0 0 120 120;" xml:space="preserve">
<style type="text/css">
	.building-area0{fill:none;stroke:#0A055F;stroke-width:2.6562;stroke-miterlimit:10;}
	.building-area1{fill:none;stroke:#FF4114;stroke-width:2.6562;stroke-miterlimit:10;}
</style>
<g>
	<path class="building-area0" d="M117.5,60c0,31.7-25.8,57.5-57.5,57.5S2.5,91.7,2.5,60S28.3,2.5,60,2.5S117.5,28.3,117.5,60z"/>
	<path class="building-area0" d="M64.4,14.5c0,1.8-1.4,3.3-3.3,3.3c-1.8,0-3.3-1.4-3.3-3.3s1.4-3.3,3.3-3.3C63,11.2,64.4,12.7,64.4,14.5z"/>
	<line class="building-area1" x1="71.2" y1="69.7" x2="80.7" y2="69.7"/>
	<line class="building-area1" x1="71.2" y1="61.1" x2="71.2" y2="86"/>
	<line class="building-area0" x1="58.7" y1="33.1" x2="36.2" y2="50.6"/>
	<line class="building-area0" x1="86.3" y1="50.6" x2="63.8" y2="33.1"/>
	<path class="building-area0" d="M66.6,28.4c0,3-2.4,5.5-5.5,5.5c-3,0-5.5-2.4-5.5-5.5s2.4-5.5,5.5-5.5v-5.3"/>
	<rect x="61.8" y="61.1" class="building-area1" width="19" height="24.1"/>
	<rect x="29.7" y="50.6" class="building-area0" width="64.4" height="45.6"/>
</g>
</svg>
`);

export const BuildingAreaIcon: React.SFC<{ iconClassName?: string }> = (props: { iconClassName?: string }) => (
  <BuildingAreaPure className={props.iconClassName} />
);

BuildingAreaIcon.displayName = 'BuildingAreaIcon';
